import React, { useEffect, useState } from 'react';
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import ZeusTable2 from 'components/tables/ZeusTable2.tsx'
import { ShowDate, ShowStatus, SingleAction } from 'components/tables/tableTools'

import {
  createColumnHelper,
  Table as ReactTable
} from '@tanstack/react-table'

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});

export default function Licenses() {
  const [iteration, setIteration] = useState(0)

  // Table data
  const [data, setData] = React.useState({})

  async function getLicenseData() {
    try {
      const resLicenses = await API.post("/admin/licenses");
      setData(resLicenses.data);
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
    }
  }
  useEffect(() => {
    getLicenseData()
  }, [iteration])

  const toggleStatus = async (id) => {
    try {
      const resLicense = await API.post("/admin/licenses/toggle-status", {id: id});
      toast.success("License status changed")
      getLicenseData()
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
    }
  };

  const columnHelper = createColumnHelper()
  const columns = [
    columnHelper.accessor(row => row.id, {
      id: 'ID',
      header: () => <span>ID</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.user_email, {
      id: 'User ID',
      cell: info => info.getValue(),
      header: () => <span>User ID</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.lcode, {
      id: 'Email',
      cell: info => info.getValue(),
      header: () => <span>lcode</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.status, {
      id: 'Status',
      header: () => <span>Status</span>,
      cell: props => <ShowStatus row={props.row} />,
      meta: {
        className: 'd-none d-md-table-cell',
      },
      footer: info => info.column.id,
    }),
    columnHelper.display({
      id: 'Actions',
      cell: info => <SingleAction id={info.row.original.id} status={info.row.original.status} function={toggleStatus} />,
    }),
    columnHelper.accessor(row => row.create_datetime, {
      id: 'Registration Date',
      header: () => <span>Registration Date</span>,
      cell: props => <ShowDate row={props.row.original.create_datetime} />,
      footer: info => info.column.id,
    })
  ]

    return (
      <div>
        <div>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </div>
        <div className="header pb-6">
          <div className="container-fluid">
            <div className="header-body">
              <div className="row align-items-center py-4">
                <div className="col-lg-6 col-7">
                  <h2 className="h2 d-inline-block mb-0">ViCANDo Licenses</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid mt--6" style={{minHeight: '100vh'}}>
          <div className="card">
            <ZeusTable2
              columns={columns}
              data={data}
            
              createLabel="Add New User"
              refreshData={getLicenseData}
            />
          </div>
        </div>
      </div>
    );
}